module.exports = __webpack_public_path__ + "img/kotlin.199cbbd8.svg";